/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useContext, useEffect, useRef, useState,} from 'react';
import Paper from '@material-ui/core/Paper';
import ImputComponent from './InputComponent';
import Grid from '@material-ui/core/Grid';
import {IListings} from '../interfaces/TableComponent';
import {ApiCallsFactory, FeatureFlag, LocalPersistence, MutationsFactory, SortFactory,} from '../factories/index';
import {PropertySearch} from '../factories/propertySearchs/';
import SearchDebounceBar from './SearchDebounce';
import {optionsForViewOptions} from '../constants/index';
import ButtonDinamyc from './ButtonDinamyc';
import Loading from './Loading';
import SearchIcon from '@material-ui/icons/Search';
import ModalDimayc from './ModalDinamyc';
import AddProperty from './AddProperty';
import {useLanguage} from '../store/languageContext';
import {LanguageFactory} from '@factories/Utilities/languageFactory';
import {Empty, Modal, Table} from 'antd';
import PopUp from './ui/PopUp';
import {SESSION_KEYS, TITLE} from '../constants';
// import { CapitalizeFirstLetter } from '../helpers/misc/CapitalizeFirstLetter'
import {CapitalizeFirstLetter} from '@helpers/misc/CapitalizeFirstLetter';
import {useHistory} from 'react-router-dom';
import {getSession, getSupplier} from '../helpers/users';
import {removeColumnsByTitle} from '../helpers/utils';
import FilterDropdown from './FilterPopup/FilterDropdown';
import {getChainsForUser} from '../../src/components/UserManagement/helper';
import {FilterOutlined} from '@ant-design/icons';
import {PropertyParamsContext} from 'src/store/propertyParamsContext';
import {usePersistedStateSessionStorage} from '../store/persistedStateSessionStorage';

declare global {
  interface Window {
    breadcrumbInfo: string;
  }
}
interface PropertyParams {
  supplier: string;
  propertyid: string | undefined;
}

type TableInfoType = {
  city: string;
  country: string;
  id: string;
  key: string;
  name: string;
  status: string;
};

type SearchDataType = {
  errors?: [];
  properties?: TableInfoType[];
  result?: {
    success: boolean;
  };
};

const columns = [
  {
    title: 'Property ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Property Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Chain',
    dataIndex: 'chain',
    key: 'chain',
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Country',
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: 'City',
    dataIndex: 'city',
    key: 'city',
  },
];

enum ChainNumber {
  undefined,
  one,
  multiple,
}
const ListingSearch = () => {
  const pageCount = [10, 20, 50, 75, 100];
  const [listings, setListings] = useState<any[]>([]);
  const [cacheData, setCacheData] = useState<IListings[]>([]);
  const [cacheChunkData, setChunkCacheData] = useState<IListings[]>([]);
  const [pages, setPages] = useState<number[]>([0]);
  const [searchs, setSearch] = useState<string[]>([]);
  const [page, setPage] = useState<number>(0);
  const [itemsXpage, setItemsXpage] = useState<number>(1);
  const [DisplayModeOption, setDisplayModeOption] = useState<string>('');
  const [rowsSize, setRowSize] = useState<string>('py-3 px-2');
  const [ColumnViewOptions, setColumnViewOptions] = useState<object[]>(
    optionsForViewOptions
  );
  const [columnsWidth, setColumnsWidth] = useState<string[]>([
    'col-2',
    'col-4',
    'col-3',
    'col-3',
  ]);
  const [headerDisplay, setHeaderDisplay] = useState<string[]>([
    'd-block',
    'd-block',
    'd-block',
    'd-block',
  ]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [ready, setReady] = useState<boolean>(false);
  const { language, setLanguage } = useLanguage();
  const lang = new LanguageFactory(language);
  const history = useHistory();
  const [data, setData] = useState<object[]>([]);
  const [propertyList, setPropertyList] = useState<object[]>([]);
  const [total, setTotal] = useState(propertyList.length);
  const [canUpdateStatus, setCanUpdateStatus] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const { state: filterParams, setState: setFilterParams } =
    usePersistedStateSessionStorage({
      key: SESSION_KEYS.PROPERTY_PARAMS_SESSION,
      defaultValue: { propertyid: '', selectedSupplier: '' },
    });
  const { userChainvalues, setUserChainvalues } = useContext(
    PropertyParamsContext
  );
  const [filtered, setFiltered] = useState<boolean>(false);
  const [numberOfChains, setNumberOfChains] = useState<ChainNumber>(
    ChainNumber.undefined
  );

  const ModalHead = () => {
    return <div className="modalHead">Confirm</div>;
  };

  const { searchTerm, setSearchTerm, searchTermDebounced, onDebounce } =
    SearchDebounceBar();

  const filterData = async (query: string) => {
    const cloneData = JSON.parse(JSON.stringify(cacheData[0]));
    const filter = new SortFactory(cloneData);
    const response: any = await filter.filterByParam(query);
    const compositeData = new MutationsFactory(response);
    const chunkResp = compositeData.compositeData(pageCount[itemsXpage - 1]);
    if (query.length <= 0) {
      setPropertyList(data);
      return setListings(chunkResp);
    }
    setPage(0);

    const filterData = data.filter((item: any) => {
      const itemData: any = {};
      columns.forEach((col: any) => {
        itemData[col['dataIndex']] = item[col.dataIndex]
          ? item[col.dataIndex].toLowerCase()
          : item[col.dataIndex];
      });
      return (
        JSON.stringify(Object.values(item))
          .toLocaleLowerCase()
          .indexOf(query.toLocaleLowerCase()) > -1
      );
    });
    setPropertyList(filterData);

    return setListings(chunkResp);
  };

  const saveNewSearch = (term: string) => {
    const stackSearchs = new PropertySearch(searchs);
    setSearch(stackSearchs.add(term));
  };

  const recentlySearchs = () => {
    return searchs.map((search, index) => {
      return (
        <span
          key={index}
          onClick={() => recoverSearch(search)}
        >
          &nbsp;{search}
          {searchs.length - 1 === index ? '.' : ','}
        </span>
      );
    });
  };

  const recoverSearch = (search: string) => {
    setSearchTerm(search);
    filterData(search);
    onDebounce(search);
  };

  const afterDebounce = (term: string) => {
    if (term) {
      saveNewSearch(term);
    }
    filterData(term);
  };

  const onChangeSearch = (term: string) => {
    setSearchTerm(term);
    onDebounce(term);
  };

  const initialRender = useRef(true);

  // Modal Functionality
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    apiGetUserChainValues();
    // Set language Picker as default to EN-US
    window.sessionStorage.setItem('langId', 'EN-US');
  }, []);

  useEffect(() => {
    setTotal(propertyList.length);
  }, [propertyList]);

  const apiGetUserChainValues = async () => {
    const session = await getSessionData();
    //testing one chain
    const { user }: any = await getChainsForUser({ id: session.userId });

    let userchain: string[] = [];
    if (user.chains.length > 1) {
      setNumberOfChains(ChainNumber.multiple);
      const selectedChains: any[] = user.chains.map(
        ({ chainName }: { chainName: string }) => chainName
      );
      const filterChains = selectedChains.filter(
        (value) => value.toLocaleLowerCase() !== 'derbysoft'
      );
      userchain = filterChains;
    } else {
      //single user

      let supplier: any;
      user.chains.length === 1
        ? (supplier = getSupplier(user.chains))
        : (supplier = session.supplier);
      setFilterParams((prev: any) => ({ ...prev, selectedSupplier: supplier }));
      setNumberOfChains(ChainNumber.one);
      const userWithOneChain: string[] = [];
      userWithOneChain.push(
        user.chains.length === 1 ? user.chains[0] : session.supplier
      );
      userchain = userWithOneChain;
    }
    setUserChainvalues(userchain);
  };

  const getData = async () => {
    const sessionParam = await getSessionDataPropertyParams();

    //check if filter params is !empty-> first time logging in or session has been refreshed
    if (sessionParam.selectedSupplier) {
      const sessionParam = await getSessionDataPropertyParams();
      await setTableData( sessionParam.selectedSupplier, sessionParam?.propertyid)
    } else {
      //first time logging in
      if (numberOfChains === ChainNumber.multiple) {
        setBlankProperties();
      } else if (numberOfChains === ChainNumber.one) {
        await apiGetFIlteredProperties();
      }
    }
  };
  const setBlankProperties = () => {
    setChunkCacheData([]);
    setCacheData([]);
    setPropertyList([]);
    setData([]);
    setListings([]);
    setReady(true);
  };

  const isEmpty = (str: string): boolean => {
    return str === null || str === '';
  };

  const isSessionActive = (): boolean => {
    return (
      !isEmpty(filterParams.selectedSupplier) || !isEmpty(filterParams.propertyid)
    );
  };

  const getSessionData = async () => {
    const get_session = new LocalPersistence('session');
    const session = await get_session.getSessionPersistence();
    return session;
  };
  const getSessionDataPropertyParams = async () => {
    const get_session = new LocalPersistence('propertyparams');
    const session = await get_session.getSessionPersistence();
    return session;
  };
  const getPropertyParams = (propertyParams: PropertyParams) => {
    const params = new URLSearchParams();

    if (propertyParams.supplier)
      params.append('supplier', propertyParams.supplier);
    if (propertyParams.propertyid)
      params.append('propertyid', propertyParams.propertyid);
    return params;
  };

  const apiGetFIlteredProperties = async (supplier? : string, hotelCode?: string) => {
    if (supplier) {
      await setTableData(supplier, hotelCode)
    } else if(isSessionActive()){
      const sessionParam = await getSessionDataPropertyParams();
      await setTableData( sessionParam.selectedSupplier, sessionParam?.propertyid)
    }
  };

  const setTableData = async (supplier: string, hotelCode?: string) => {
    const session = await getSessionData();
    const filteredCall = new ApiCallsFactory(`/search`, session.token);
    let searchData: SearchDataType = {};

    searchData = await filteredCall.getData(
        getPropertyParams({
          supplier: supplier.toLocaleLowerCase().includes('derbysoft')
              ? supplier
              : supplier,
          propertyid: hotelCode,
        })
    );

    const response: object[] = searchData.properties || [];
    const compositeData = new MutationsFactory(response);

    const chunkResp = compositeData.compositeData(pageCount[itemsXpage - 1]);
    setChunkCacheData(chunkResp);
    setCacheData([response]);

    response.forEach((item: any, index: number) => {
      item.key = '' + index;
    });

    setPropertyList(response);
    setData(response);
    setListings(chunkResp);
    setReady(true);
  }
  //apply clicked
  const setFilteredProperties = async (supplier?:string, hotelCode?:string) => {
    toggleFilter();
    setBlankProperties();
    setReady(false);
    updateFilteredParams(supplier, hotelCode)
    await apiGetFIlteredProperties(supplier, hotelCode);
    setReady(true)
    setFiltered(true);
  };
  const setPropertyID = (value: string) => {
    setFilterParams((prev: object) => ({ ...prev, propertyid: value }));
  };
  const setSelectedChain = (value: string) => {
    setFilterParams((prev: object) => ({ ...prev, selectedSupplier: value }));
  };
  const updateFilteredParams = (supplier?: string, hotelCode?:string) => {
    setFilterParams((prev: object) => ({ propertyid: hotelCode, selectedSupplier: supplier }));

  }
  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const dispatchPropertyAction = async (status: string, id: string) => {
    const sessionSupplierParams = await getSessionDataPropertyParams();
    const sessionToken = await  getSessionData();

    debugger
    const newStatus = status === 'deactivated' ? 'active' : 'deactivated';
    const body = {};
    const handleStatus = new ApiCallsFactory(
      `/manage-status/property/${sessionSupplierParams.selectedSupplier}/${id}?status=${newStatus}`,
      sessionToken.token, body
    );

    const response = await handleStatus.putData();
    if (response && response['result']['success']) {
      //apiGetData();
      setReady(false);
      await getData();
      setReady(true)
    }
  };

  const handlePropertyStatus = useCallback(
    (e: React.MouseEvent, status: string, id: string) => {
      e.stopPropagation();
      Modal.confirm({
        title: <ModalHead />,
        centered: true,
        icon: '',
        content: `Are you sure you want to ${
          status === 'deactivated' ? 'activate' : 'deactivate'
        }?`,
        cancelText: 'Cancel',
        okText: status === 'deactivated' ? 'Activate' : 'Deactivate',
        onOk: () => dispatchPropertyAction(status, id),
      });
    },
    []
  );

  const tableAction = {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center' as 'center',
    render: (text: object, record: TableInfoType) => (
      <PopUp
        trigger="click"
        color="white"
        placement="bottomRight"
        opts={[
          {
            title: record.status === 'deactivated' ? 'Activate' : 'Deactivate',
            action: (e) => handlePropertyStatus(e, record.status, record.id),
          },
        ]}
      />
    ),
  };

  const tableStatus = {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    // sortDirections: ['ascend', 'descend'],
    // sorter: (a:object, b:object) => a['status'].localeCompare(b['status']),
    render: (text: any, record: TableInfoType) => (
      <div className="status-wrapper">
        <span
          className={
            'status-indicator ' +
            (record.status === 'deactivated' ? 'deactivated' : 'active')
          }
        ></span>
        <p>{CapitalizeFirstLetter(record.status)}</p>
      </div>
    ),
  };

  const FeatureFlags = useCallback(async () => {
    const propertyContentFlag = new FeatureFlag(
      process.env.REACT_APP_TABLE_STATUS
    );
    const userManagementFlag = new FeatureFlag(
      process.env.REACT_APP_TABLE_ACTION
    );

    propertyContentFlag.validationByFilter({
      validationParam: TITLE,
      source: columns,
      resources: tableStatus,
    });

    userManagementFlag.validationByFilter({
      validationParam: TITLE,
      source: columns,
      resources: tableAction,
    });

    const session = (await getSession()) as { role: string };
    const role = session?.role?.toLowerCase();

    // can update status
    const flag = !!session.role && (role?.includes('admin') || role === 'user');

    // if is not admin or 'user', removing the selected column
    if (!flag) {
      removeColumnsByTitle({
        columns,
        toBeRemoved: ['action']
      });
    }

    // persiting the admin value as going to be used on the view
    setCanUpdateStatus(flag);
  }, []);

  useEffect(() => {
    // removing breadcrumb data
    window.breadcrumbInfo = '';
    getData();
    FeatureFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userChainvalues]);

  // search functionality
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      afterDebounce(searchTermDebounced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTermDebounced]);

  // page number to display data by page
  useEffect(() => {
    const tempArray: number[] = [];
    cacheChunkData.map((item, index) => {
      return tempArray.push(index);
    });
    setPages(tempArray);
  }, [cacheChunkData]);

  // page number to display data by page
  useEffect(() => {
    const tempArray: number[] = [];
    let totalArray: number = 0;
    listings.map((item, index) => {
      item.map(() => (totalArray += 1));
      return tempArray.push(index);
    });
    setPages(tempArray);
    setTotalCount(totalArray);
  }, [listings]);

  // split data into chunks
  useEffect(() => {
    const cloneData = cacheData[0]
      ? JSON.parse(JSON.stringify(cacheData[0]))
      : [];
    const compositeData = new MutationsFactory(cloneData);
    const chunkResp = compositeData.compositeData(pageCount[itemsXpage - 1]);
    if (searchTerm !== '') filterData(searchTerm);
    setPage(0);
    setListings(chunkResp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsXpage, cacheData, data]);

  // rows heigth
  useEffect(() => {
    function viewOptionsHeigth(type: string): void {
      switch (type) {
        case 'Compact':
          return setRowSize('py-2 px-1');
        case 'Comfortable':
          return setRowSize('py-4 px-3');
        default:
          return setRowSize('py-3 px-2');
      }
    }
    viewOptionsHeigth(DisplayModeOption);
  }, [DisplayModeOption]);

  // show - hide rows
  useEffect(() => {
    const columnsTempArray: string[] = [];
    const headersTempArray: string[] = [];
    let enabledButtons: number = 0;
    let tempData: { disabled?: boolean } = {};
    ColumnViewOptions.map((cvo: any, index: number) => {
      // if it checked
      if (!cvo.checked) {
        headersTempArray.push(`${headerDisplay[index]} d-none`);
        return columnsTempArray.push(`${columnsWidth[index]} d-none`);
      } else {
        enabledButtons += 1;
        tempData = cvo;
      }

      const clw = columnsWidth[index];
      const value = clw.split(' ');

      const hed = headerDisplay[index];
      const hedValue = hed.split('');

      cvo.disabled = false;
      headersTempArray.push(hedValue[0]);
      return columnsTempArray.push(value[0]);
    });

    // gray out if remains one option
    if (enabledButtons < 2) {
      tempData.disabled = true;
    }
    setHeaderDisplay(headersTempArray);
    return setColumnsWidth(columnsTempArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ColumnViewOptions]);

  /**
    * The 'Add Filter' link button is displayed
    * only if the user has multiple chains && properties were not be filtered
    */
  const displayAddFilter: boolean = (!filtered && numberOfChains === ChainNumber.multiple)

  const locale = {
    emptyText: displayAddFilter ? (
      <Empty
        description={
          <span>
            Please click on{' '}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="span" onClick={toggleFilter}>
              Add filter
            </a>
          </span>
        }
      />) :
      /**
        * TODO: May be should display create new property here?
        */
      null,
  };

  const goToDetails = async (
    propertyId: string,
    data?: {
      name: string;
      status: string;
    }
  ) => {
    // if property is deactive return
    if (data?.status === 'deactivated') return;
    // if propertyId EXIST
    if (propertyId) {
      const get_session = new LocalPersistence('session');
      const session = await get_session.getSessionPersistence();
      const filterParams = await getSessionDataPropertyParams();
      const supplier = filterParams.selectedSupplier;
      const propertyName = data?.name || '';
      // setting up the property id on the session storage
      const persistingPropertyId = new LocalPersistence('session', {
        ...session,
        propertyId,
        propertyName,
        supplier,
      });
      await persistingPropertyId.setSessionPersistence();
      // redirect to details page
      return history.push(`/detailPage`);
    }
  };

  return (
    <>
      {listings.length <= 0 && !ready ? (
        <Loading type="large" />
      ) : (
        <>
          <Grid
            item
            xs={12}
            className="containerSpacing p-0 h-55"
          >
            <Paper
              elevation={1}
              square
              className="containerSpacing d-flex flex-end p-0"
            >
              <Grid
                container
                spacing={0}
                className="containerSpacing py-0 m-0"
                justify="flex-end"
              >
                {filterParams?.selectedSupplier && (
                  <ButtonDinamyc
                    message="Add New Property"
                    classes="lightBlueDS text-ligthBlue"
                    //disable={filterParams.selectedSupplier.length <= 0}
                    action={handleOpen}
                  />
                )}
              </Grid>
            </Paper>
          </Grid>
          <Grid
            container
            spacing={0}
            className="containerSpacing py-0"
          >
            <Grid
              item
              xs={12}
              className="pb-0 px-0 my-0"
            >
              <div className="property-grid">
                <div style={{ width: 400 }}>
                  <ImputComponent
                    className="SearchBar"
                    label={lang.translate(language, 'search')}
                    labelShrink={true}
                    value={searchTerm}
                    onChange={onChangeSearch}
                    placeholder={lang.translate(
                      language,
                      'property_search_placeholder'
                    )}
                    endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                  />
                  <div className="recentlySearchs">
                    <p>
                      {lang.translate(language, 'recently_searched')}:{' '}
                      {recentlySearchs()}
                    </p>
                  </div>
                </div>

                {userChainvalues.length > 1 && (
                  <div className="filter">
                    <div style={{ height: 25.5 }}>
                      <FilterOutlined style={{ color: '#9a9a9a' }} />
                    </div>
                    <span
                      className="span"
                      onClick={toggleFilter}
                    >
                      AddFilter
                    </span>
                  </div>
                )}
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              className="p-0"
            >
              <Paper
                elevation={1}
                square
                className="containerSpacing py-1"
              >
                <Table
                  columns={columns}
                  locale={locale}
                  dataSource={propertyList}
                  // grayout icon when the row is deactivated
                  rowClassName={(record) =>
                    record.status === 'deactivated' && !canUpdateStatus
                      ? 'soft-grayout'
                      : 'c-pointer'
                  }
                  pagination={{
                    size: 'small',
                    total,
                    showSizeChanger: true,
                    showTotal: (total, range) =>
                      `Total ${total} items, Current ${range[0]}-${range[1]}`,
                    defaultPageSize: 10,
                    defaultCurrent: 1,
                    onChange: (page, pageSize) => {
                      console.log(page + '===' + pageSize);
                    },
                  }}
                  onRow={(record: any) => {
                    return {
                      onClick: () => {
                        goToDetails(record.id, record);
                      },
                    };
                  }}
                />
              </Paper>
            </Grid>
          </Grid>
          <ModalDimayc
            open={open}
            title="Add Property"
            content={<AddProperty setOpen={setOpen} />}
          />
          {isFilterOpen && (
            <FilterDropdown
              userChains={userChainvalues}
              closeFilterForm={toggleFilter}
              getFilterData={setFilteredProperties}
              propertyid={filterParams.propertyid}
              updateFilterParams={updateFilteredParams}
            />
          )}
        </>
      )}
    </>
  );
};

export default ListingSearch;
